module.exports = {
  title: 'Airbnb Slider with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2023-11-01',
  slug: 'airbnb-slider',
  tags: ['reanimated', 'gesture-handler'],
};
